export const GITHUB_URL = 'https://github.com/aftongauntlett';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/afton-gauntlett/';
export const RESUME_URL = 'https://aftongauntlett.github.io/resume/';
